"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIClient = void 0;
var clients_1 = require("src/clients");
var models_1 = require("src/models");
var BASE_URL = "".concat(models_1.EndpointsV1.ai, "/");
/**
 * SDK for interacting with the AI Services API's such as Text Generation and Text to SQL
 * ### Example Text Generation Usage
 * ```js
 * import { AIClient } from '@domoinc/toolkit';
 *
 * interface PromptTemplate {
 *      template: string;
 * }
 *
 * interface Context {
 *      input: string;
 *      promptTemplate?: PromptTemplate;
 *      parameters?: Record<string, string>;
 *      model?: string;
 *      modelConfiguration?: Record<string, Object>;
 * }
 * const aiClient = new AIClient<Context>();
 *
 * const generateText = async (input: string, promptTemplate?: PromptTemplate, parameters?: Record<string, string>, model?: string, modelConfiguration?: Record<string, Object>) =>
 *     aiClient.generate_text(input, promptTemplate, parameters, model, modelConfiguration);
 * ```
 * ### Example Text To SQL Usage
 * ```js
 * import { AIClient } from '@domoinc/toolkit';
 *
 * interface PromptTemplate {
 *      template: string;
 * }
 *
 * interface DataSourceSchema {
 *      dataSourceName: string;
 *      description: string;
 *      columns: Column[];
 * }
 *
 *
 * const aiClient = new AIClient<aiClient>();
 *
 * const textToSQL = async (input: string, dataSourceSchemas: DataSourceSchema[], promptTemplate?: PromptTemplate, parameters?: Record<string, string>, model?: string, modelConfiguration?: Record<string, Object>) =>
 *    aiClient.text_to_sql(input, dataSourceSchemas, promptTemplate, parameters, model, modelConfiguration);
 *
 * ```
 */
var AIClient = /** @class */ (function () {
    function AIClient() {
    }
    AIClient.generate_text = function (input, promptTemplate, parameters, model, modelConfiguration) {
        var textGenerationRequest = {
            input: input,
            promptTemplate: promptTemplate !== null && promptTemplate !== void 0 ? promptTemplate : null,
            parameters: parameters !== null && parameters !== void 0 ? parameters : null,
            model: model !== null && model !== void 0 ? model : null,
            modelConfiguration: modelConfiguration !== null && modelConfiguration !== void 0 ? modelConfiguration : null
        };
        return clients_1.TransportClient.post("".concat(BASE_URL, "text/generation"), JSON.stringify(textGenerationRequest), this.headers);
    };
    AIClient.text_to_sql = function (input, dataSourceSchemas, promptTemplate, parameters, model, modelConfiguration) {
        var textToSQLRequest = {
            input: input,
            dataSourceSchemas: dataSourceSchemas !== null && dataSourceSchemas !== void 0 ? dataSourceSchemas : [],
            promptTemplate: promptTemplate !== null && promptTemplate !== void 0 ? promptTemplate : null,
            parameters: parameters !== null && parameters !== void 0 ? parameters : null,
            model: model !== null && model !== void 0 ? model : null,
            modelConfiguration: modelConfiguration !== null && modelConfiguration !== void 0 ? modelConfiguration : null
        };
        return clients_1.TransportClient.post("".concat(BASE_URL, "text/sql"), JSON.stringify(textToSQLRequest), this.headers);
    };
    AIClient.summarize = function (input, promptTemplate, parameters, model, modelConfiguration, system, chatContext, chunkingConfiguration, outputStyle, outputWordLength) {
        var summarizationRequest = {
            input: input,
            promptTemplate: promptTemplate !== null && promptTemplate !== void 0 ? promptTemplate : null,
            parameters: parameters !== null && parameters !== void 0 ? parameters : null,
            model: model !== null && model !== void 0 ? model : null,
            modelConfiguration: modelConfiguration !== null && modelConfiguration !== void 0 ? modelConfiguration : null,
            system: system !== null && system !== void 0 ? system : null,
            chatContext: chatContext !== null && chatContext !== void 0 ? chatContext : null,
            chunkingConfiguration: chunkingConfiguration !== null && chunkingConfiguration !== void 0 ? chunkingConfiguration : null,
            outputStyle: outputStyle !== null && outputStyle !== void 0 ? outputStyle : null,
            outputWordLength: outputWordLength !== null && outputWordLength !== void 0 ? outputWordLength : null
        };
        return clients_1.TransportClient.post("".concat(BASE_URL, "text/summarize"), JSON.stringify(summarizationRequest), this.headers);
    };
    AIClient.text_to_beastmode = function (input, dataSourceSchema, promptTemplate, parameters, model, modelConfiguration, system, chatContext) {
        var textToBeastModeRequest = {
            input: input,
            dataSourceSchema: dataSourceSchema !== null && dataSourceSchema !== void 0 ? dataSourceSchema : null,
            promptTemplate: promptTemplate !== null && promptTemplate !== void 0 ? promptTemplate : null,
            parameters: parameters !== null && parameters !== void 0 ? parameters : null,
            model: model !== null && model !== void 0 ? model : null,
            modelConfiguration: modelConfiguration !== null && modelConfiguration !== void 0 ? modelConfiguration : null,
            system: system !== null && system !== void 0 ? system : null,
            chatContext: chatContext !== null && chatContext !== void 0 ? chatContext : null
        };
        return clients_1.TransportClient.post("".concat(BASE_URL, "text/beastmode"), JSON.stringify(textToBeastModeRequest), this.headers);
    };
    AIClient.headers = {
        accept: models_1.DataFormatTypes.json,
        'Content-type': models_1.DataFormatTypes.json,
    };
    return AIClient;
}());
exports.AIClient = AIClient;
